import { render, staticRenderFns } from "./Cryptopay.vue?vue&type=template&id=0bd5f168&scoped=true&"
import script from "./Cryptopay.vue?vue&type=script&lang=js&"
export * from "./Cryptopay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5f168",
  null
  
)

export default component.exports